// This file is auto-generated by @hey-api/openapi-ts

import { type Client, type ClientMeta, formDataBodySerializer, type Options as Options2, type RequestResult, type TDataShape } from './client';
import { client } from './client.gen';
import type { ActivateClientData, ActivateClientErrors, ActivateClientResponses, CreateApiTokenData, CreateApiTokenErrors, CreateApiTokenResponses, CreateApplicationData, CreateApplicationErrors, CreateApplicationResponses, CreateAttachmentData, CreateAttachmentErrors, CreateAttachmentResponses, CreateClientData, CreateClientErrors, CreateClientResponses, CreateClientUserData, CreateClientUserErrors, CreateClientUserResponses, CreateInternalUserData, CreateInternalUserErrors, CreateInternalUserResponses, CreateIssueCommentData, CreateIssueCommentErrors, CreateIssueCommentResponses, CreateIssueData, CreateIssueErrors, CreateIssueFromActionItemData, CreateIssueFromActionItemErrors, CreateIssueFromActionItemResponses, CreateIssueResponses, CreateLinkCategoryData, CreateLinkCategoryErrors, CreateLinkCategoryResponses, CreateLinkData, CreateLinkErrors, CreateLinkResponses, CreateMeetingData, CreateMeetingDecisionData, CreateMeetingDecisionErrors, CreateMeetingDecisionResponses, CreateMeetingErrors, CreateMeetingResponses, CreateProjectData, CreateProjectErrors, CreateProjectMilestoneData, CreateProjectMilestoneErrors, CreateProjectMilestoneResponses, CreateProjectResponses, CreateTimesheetEntryData, CreateTimesheetEntryErrors, CreateTimesheetEntryResponses, DeactivateClientData, DeactivateClientErrors, DeactivateClientResponses, DeleteApplicationData, DeleteApplicationErrors, DeleteApplicationResponses, DeleteAttachmentData, DeleteAttachmentErrors, DeleteAttachmentResponses, DeleteClientUserData, DeleteClientUserErrors, DeleteClientUserResponses, DeleteGitlabTokenData, DeleteGitlabTokenErrors, DeleteGitlabTokenResponses, DeleteIssueData, DeleteIssueErrors, DeleteIssueResponses, DeleteLinkCategoryData, DeleteLinkCategoryErrors, DeleteLinkCategoryResponses, DeleteLinkData, DeleteLinkErrors, DeleteLinkResponses, DeleteMeetingData, DeleteMeetingErrors, DeleteMeetingResponses, DeleteMilestoneData, DeleteMilestoneErrors, DeleteMilestoneResponses, DeleteProjectData, DeleteProjectDocumentData, DeleteProjectDocumentErrors, DeleteProjectDocumentResponses, DeleteProjectErrors, DeleteProjectResponses, DeleteTimesheetEntryData, DeleteTimesheetEntryErrors, DeleteTimesheetEntryResponses, DownloadAttachmentData, DownloadAttachmentErrors, DownloadAttachmentResponses, DownloadFileData, DownloadFileErrors, DownloadFileResponses, DownloadProjectDocumentData, DownloadProjectDocumentErrors, DownloadProjectDocumentResponses, EnableClientPortalData, EnableClientPortalErrors, EnableClientPortalResponses, GetAdminTimesheetOverviewData, GetAdminTimesheetOverviewErrors, GetAdminTimesheetOverviewResponses, GetClientData, GetClientErrors, GetClientResponses, GetGitlabTokenStatusData, GetGitlabTokenStatusErrors, GetGitlabTokenStatusResponses, GetIssueData, GetIssueErrors, GetIssueResponses, GetMeData, GetMeErrors, GetMeetingData, GetMeetingErrors, GetMeetingResponses, GetMeResponses, GetMyClientData, GetMyClientErrors, GetMyClientResponses, GetTimesheetSettingsData, GetTimesheetSettingsErrors, GetTimesheetSettingsResponses, HandleGitlabWebhookData, HandleGitlabWebhookErrors, HandleGitlabWebhookResponses, ImportFileFromUrlData, ImportFileFromUrlErrors, ImportFileFromUrlResponses, LinkActionItemData, LinkActionItemErrors, LinkActionItemResponses, ListActionItemCandidatesData, ListActionItemCandidatesErrors, ListActionItemCandidatesResponses, ListAllApiTokensData, ListAllApiTokensErrors, ListAllApiTokensResponses, ListApplicationsData, ListApplicationsErrors, ListApplicationsResponses, ListClientLabelsData, ListClientLabelsErrors, ListClientLabelsResponses, ListClientProjectsData, ListClientProjectsErrors, ListClientProjectsResponses, ListClientsData, ListClientsErrors, ListClientsResponses, ListClientUsersData, ListClientUsersErrors, ListClientUsersResponses, ListGitlabMergeRequestsData, ListGitlabMergeRequestsErrors, ListGitlabMergeRequestsResponses, ListInternalDirectoryData, ListInternalDirectoryErrors, ListInternalDirectoryResponses, ListInternalUsersData, ListInternalUsersErrors, ListInternalUsersResponses, ListIssueMergeRequestsData, ListIssueMergeRequestsErrors, ListIssueMergeRequestsResponses, ListIssuesData, ListIssuesErrors, ListIssuesResponses, ListLinkCategoriesData, ListLinkCategoriesErrors, ListLinkCategoriesResponses, ListLinksData, ListLinksErrors, ListLinksResponses, ListMeetingsData, ListMeetingsErrors, ListMeetingsResponses, ListMyApiTokensData, ListMyApiTokensErrors, ListMyApiTokensResponses, ListPortalClientsData, ListPortalClientsErrors, ListPortalClientsResponses, ListProjectDocumentsData, ListProjectDocumentsErrors, ListProjectDocumentsResponses, ListProjectMilestonesData, ListProjectMilestonesErrors, ListProjectMilestonesResponses, ListProjectOverviewData, ListProjectOverviewErrors, ListProjectOverviewResponses, ListTimesheetCatalogApplicationsData, ListTimesheetCatalogApplicationsErrors, ListTimesheetCatalogApplicationsResponses, ListTimesheetCatalogClientsData, ListTimesheetCatalogClientsErrors, ListTimesheetCatalogClientsResponses, ListTimesheetCatalogProjectsData, ListTimesheetCatalogProjectsErrors, ListTimesheetCatalogProjectsResponses, ListTimesheetEntriesData, ListTimesheetEntriesErrors, ListTimesheetEntriesResponses, ListTrackerProjectsData, ListTrackerProjectsErrors, ListTrackerProjectsResponses, LivenessData, LivenessErrors, LivenessResponses, LookupIssuesData, LookupIssuesErrors, LookupIssuesResponses, LookupTimesheetIssueData, LookupTimesheetIssueErrors, LookupTimesheetIssueResponses, PublishMeetingData, PublishMeetingErrors, PublishMeetingResponses, ReadinessData, ReadinessErrors, ReadinessResponses, ReorderLinkCategoriesData, ReorderLinkCategoriesErrors, ReorderLinkCategoriesResponses, ReorderLinksData, ReorderLinksErrors, ReorderLinksResponses, ResetClientUserPasswordData, ResetClientUserPasswordErrors, ResetClientUserPasswordResponses, ResetInternalUserPasswordData, ResetInternalUserPasswordErrors, ResetInternalUserPasswordResponses, ResolveIssueIdentifierData, ResolveIssueIdentifierErrors, ResolveIssueIdentifierResponses, ReviewMeetingData, ReviewMeetingErrors, ReviewMeetingResponses, RevokeApiTokenAsAdminData, RevokeApiTokenAsAdminErrors, RevokeApiTokenAsAdminResponses, RevokeMyApiTokenData, RevokeMyApiTokenErrors, RevokeMyApiTokenResponses, SearchMeetingParticipantsData, SearchMeetingParticipantsErrors, SearchMeetingParticipantsResponses, SetGitlabTokenData, SetGitlabTokenErrors, SetGitlabTokenResponses, SetInternalUserEnabledData, SetInternalUserEnabledErrors, SetInternalUserEnabledResponses, SetInternalUserRoleData, SetInternalUserRoleErrors, SetInternalUserRoleResponses, SetIssueAssigneeData, SetIssueAssigneeErrors, SetIssueAssigneeResponses, SetIssueFlagsData, SetIssueFlagsErrors, SetIssueFlagsResponses, SetIssueParentData, SetIssueParentErrors, SetIssueParentResponses, SetIssueStateData, SetIssueStateErrors, SetIssueStateResponses, SetIssueValidationData, SetIssueValidationErrors, SetIssueValidationResponses, SetMeetingAttendeesData, SetMeetingAttendeesErrors, SetMeetingAttendeesResponses, SetProjectBudgetData, SetProjectBudgetErrors, SetProjectBudgetResponses, SetProjectClosureData, SetProjectClosureErrors, SetProjectClosureResponses, SetTimesheetSettingsData, SetTimesheetSettingsErrors, SetTimesheetSettingsResponses, SummarizeMeetingData, SummarizeMeetingErrors, SummarizeMeetingResponses, UnpublishMeetingData, UnpublishMeetingErrors, UnpublishMeetingResponses, UpdateActionItemData, UpdateActionItemErrors, UpdateActionItemResponses, UpdateApplicationData, UpdateApplicationErrors, UpdateApplicationResponses, UpdateClientData, UpdateClientErrors, UpdateClientResponses, UpdateClientUserData, UpdateClientUserErrors, UpdateClientUserResponses, UpdateInternalUserData, UpdateInternalUserErrors, UpdateInternalUserResponses, UpdateIssueCommentData, UpdateIssueCommentErrors, UpdateIssueCommentResponses, UpdateIssueData, UpdateIssueErrors, UpdateIssueResponses, UpdateLinkCategoryData, UpdateLinkCategoryErrors, UpdateLinkCategoryResponses, UpdateLinkData, UpdateLinkErrors, UpdateLinkResponses, UpdateMeetingData, UpdateMeetingDecisionData, UpdateMeetingDecisionErrors, UpdateMeetingDecisionResponses, UpdateMeetingErrors, UpdateMeetingResponses, UpdateMilestoneData, UpdateMilestoneErrors, UpdateMilestoneResponses, UpdateProjectDetailsData, UpdateProjectDetailsErrors, UpdateProjectDetailsResponses, UpdateTimesheetEntryData, UpdateTimesheetEntryErrors, UpdateTimesheetEntryResponses, UploadFileData, UploadFileErrors, UploadFileResponses, UploadProjectDocumentData, UploadProjectDocumentErrors, UploadProjectDocumentResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

export const getMe = <ThrowOnError extends boolean = false>(options?: Options<GetMeData, ThrowOnError>): RequestResult<GetMeResponses, GetMeErrors, ThrowOnError> => (options?.client ?? client).get<GetMeResponses, GetMeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/me',
    ...options
});

export const listMyApiTokens = <ThrowOnError extends boolean = false>(options?: Options<ListMyApiTokensData, ThrowOnError>): RequestResult<ListMyApiTokensResponses, ListMyApiTokensErrors, ThrowOnError> => (options?.client ?? client).get<ListMyApiTokensResponses, ListMyApiTokensErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/profile/tokens',
    ...options
});

export const createApiToken = <ThrowOnError extends boolean = false>(options: Options<CreateApiTokenData, ThrowOnError>): RequestResult<CreateApiTokenResponses, CreateApiTokenErrors, ThrowOnError> => (options.client ?? client).post<CreateApiTokenResponses, CreateApiTokenErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/profile/tokens',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const revokeMyApiToken = <ThrowOnError extends boolean = false>(options: Options<RevokeMyApiTokenData, ThrowOnError>): RequestResult<RevokeMyApiTokenResponses, RevokeMyApiTokenErrors, ThrowOnError> => (options.client ?? client).delete<RevokeMyApiTokenResponses, RevokeMyApiTokenErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/profile/tokens/{id}',
    ...options
});

export const listAllApiTokens = <ThrowOnError extends boolean = false>(options?: Options<ListAllApiTokensData, ThrowOnError>): RequestResult<ListAllApiTokensResponses, ListAllApiTokensErrors, ThrowOnError> => (options?.client ?? client).get<ListAllApiTokensResponses, ListAllApiTokensErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/api-tokens',
    ...options
});

export const revokeApiTokenAsAdmin = <ThrowOnError extends boolean = false>(options: Options<RevokeApiTokenAsAdminData, ThrowOnError>): RequestResult<RevokeApiTokenAsAdminResponses, RevokeApiTokenAsAdminErrors, ThrowOnError> => (options.client ?? client).delete<RevokeApiTokenAsAdminResponses, RevokeApiTokenAsAdminErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/api-tokens/{id}',
    ...options
});

export const listInternalUsers = <ThrowOnError extends boolean = false>(options?: Options<ListInternalUsersData, ThrowOnError>): RequestResult<ListInternalUsersResponses, ListInternalUsersErrors, ThrowOnError> => (options?.client ?? client).get<ListInternalUsersResponses, ListInternalUsersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/users',
    ...options
});

export const createInternalUser = <ThrowOnError extends boolean = false>(options: Options<CreateInternalUserData, ThrowOnError>): RequestResult<CreateInternalUserResponses, CreateInternalUserErrors, ThrowOnError> => (options.client ?? client).post<CreateInternalUserResponses, CreateInternalUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/users',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const updateInternalUser = <ThrowOnError extends boolean = false>(options: Options<UpdateInternalUserData, ThrowOnError>): RequestResult<UpdateInternalUserResponses, UpdateInternalUserErrors, ThrowOnError> => (options.client ?? client).put<UpdateInternalUserResponses, UpdateInternalUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/users/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const setInternalUserRole = <ThrowOnError extends boolean = false>(options: Options<SetInternalUserRoleData, ThrowOnError>): RequestResult<SetInternalUserRoleResponses, SetInternalUserRoleErrors, ThrowOnError> => (options.client ?? client).put<SetInternalUserRoleResponses, SetInternalUserRoleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/users/{id}/role',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const setInternalUserEnabled = <ThrowOnError extends boolean = false>(options: Options<SetInternalUserEnabledData, ThrowOnError>): RequestResult<SetInternalUserEnabledResponses, SetInternalUserEnabledErrors, ThrowOnError> => (options.client ?? client).put<SetInternalUserEnabledResponses, SetInternalUserEnabledErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/users/{id}/enabled',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const resetInternalUserPassword = <ThrowOnError extends boolean = false>(options: Options<ResetInternalUserPasswordData, ThrowOnError>): RequestResult<ResetInternalUserPasswordResponses, ResetInternalUserPasswordErrors, ThrowOnError> => (options.client ?? client).post<ResetInternalUserPasswordResponses, ResetInternalUserPasswordErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/users/{id}/reset-password',
    ...options
});

export const listInternalDirectory = <ThrowOnError extends boolean = false>(options?: Options<ListInternalDirectoryData, ThrowOnError>): RequestResult<ListInternalDirectoryResponses, ListInternalDirectoryErrors, ThrowOnError> => (options?.client ?? client).get<ListInternalDirectoryResponses, ListInternalDirectoryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/users/internal',
    ...options
});

export const liveness = <ThrowOnError extends boolean = false>(options?: Options<LivenessData, ThrowOnError>): RequestResult<LivenessResponses, LivenessErrors, ThrowOnError> => (options?.client ?? client).get<LivenessResponses, LivenessErrors, ThrowOnError>({ url: '/health', ...options });

export const readiness = <ThrowOnError extends boolean = false>(options?: Options<ReadinessData, ThrowOnError>): RequestResult<ReadinessResponses, ReadinessErrors, ThrowOnError> => (options?.client ?? client).get<ReadinessResponses, ReadinessErrors, ThrowOnError>({ url: '/health/ready', ...options });

export const listClients = <ThrowOnError extends boolean = false>(options?: Options<ListClientsData, ThrowOnError>): RequestResult<ListClientsResponses, ListClientsErrors, ThrowOnError> => (options?.client ?? client).get<ListClientsResponses, ListClientsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/clients',
    ...options
});

export const createClient = <ThrowOnError extends boolean = false>(options: Options<CreateClientData, ThrowOnError>): RequestResult<CreateClientResponses, CreateClientErrors, ThrowOnError> => (options.client ?? client).post<CreateClientResponses, CreateClientErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/clients',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getClient = <ThrowOnError extends boolean = false>(options: Options<GetClientData, ThrowOnError>): RequestResult<GetClientResponses, GetClientErrors, ThrowOnError> => (options.client ?? client).get<GetClientResponses, GetClientErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/clients/{id}',
    ...options
});

export const updateClient = <ThrowOnError extends boolean = false>(options: Options<UpdateClientData, ThrowOnError>): RequestResult<UpdateClientResponses, UpdateClientErrors, ThrowOnError> => (options.client ?? client).put<UpdateClientResponses, UpdateClientErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/clients/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const activateClient = <ThrowOnError extends boolean = false>(options: Options<ActivateClientData, ThrowOnError>): RequestResult<ActivateClientResponses, ActivateClientErrors, ThrowOnError> => (options.client ?? client).post<ActivateClientResponses, ActivateClientErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/clients/{id}/activate',
    ...options
});

export const deactivateClient = <ThrowOnError extends boolean = false>(options: Options<DeactivateClientData, ThrowOnError>): RequestResult<DeactivateClientResponses, DeactivateClientErrors, ThrowOnError> => (options.client ?? client).post<DeactivateClientResponses, DeactivateClientErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/clients/{id}/deactivate',
    ...options
});

export const enableClientPortal = <ThrowOnError extends boolean = false>(options: Options<EnableClientPortalData, ThrowOnError>): RequestResult<EnableClientPortalResponses, EnableClientPortalErrors, ThrowOnError> => (options.client ?? client).post<EnableClientPortalResponses, EnableClientPortalErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/clients/{id}/enable-portal',
    ...options
});

export const listClientUsers = <ThrowOnError extends boolean = false>(options: Options<ListClientUsersData, ThrowOnError>): RequestResult<ListClientUsersResponses, ListClientUsersErrors, ThrowOnError> => (options.client ?? client).get<ListClientUsersResponses, ListClientUsersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/clients/{id}/users',
    ...options
});

export const createClientUser = <ThrowOnError extends boolean = false>(options: Options<CreateClientUserData, ThrowOnError>): RequestResult<CreateClientUserResponses, CreateClientUserErrors, ThrowOnError> => (options.client ?? client).post<CreateClientUserResponses, CreateClientUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/clients/{id}/users',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteClientUser = <ThrowOnError extends boolean = false>(options: Options<DeleteClientUserData, ThrowOnError>): RequestResult<DeleteClientUserResponses, DeleteClientUserErrors, ThrowOnError> => (options.client ?? client).delete<DeleteClientUserResponses, DeleteClientUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/clients/{id}/users/{userId}',
    ...options
});

export const updateClientUser = <ThrowOnError extends boolean = false>(options: Options<UpdateClientUserData, ThrowOnError>): RequestResult<UpdateClientUserResponses, UpdateClientUserErrors, ThrowOnError> => (options.client ?? client).put<UpdateClientUserResponses, UpdateClientUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/clients/{id}/users/{userId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const resetClientUserPassword = <ThrowOnError extends boolean = false>(options: Options<ResetClientUserPasswordData, ThrowOnError>): RequestResult<ResetClientUserPasswordResponses, ResetClientUserPasswordErrors, ThrowOnError> => (options.client ?? client).post<ResetClientUserPasswordResponses, ResetClientUserPasswordErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/clients/{id}/users/{userId}/reset-password',
    ...options
});

export const listPortalClients = <ThrowOnError extends boolean = false>(options?: Options<ListPortalClientsData, ThrowOnError>): RequestResult<ListPortalClientsResponses, ListPortalClientsErrors, ThrowOnError> => (options?.client ?? client).get<ListPortalClientsResponses, ListPortalClientsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/clients',
    ...options
});

export const getMyClient = <ThrowOnError extends boolean = false>(options?: Options<GetMyClientData, ThrowOnError>): RequestResult<GetMyClientResponses, GetMyClientErrors, ThrowOnError> => (options?.client ?? client).get<GetMyClientResponses, GetMyClientErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/clients/me',
    ...options
});

export const listLinks = <ThrowOnError extends boolean = false>(options?: Options<ListLinksData, ThrowOnError>): RequestResult<ListLinksResponses, ListLinksErrors, ThrowOnError> => (options?.client ?? client).get<ListLinksResponses, ListLinksErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/links',
    ...options
});

export const createLink = <ThrowOnError extends boolean = false>(options: Options<CreateLinkData, ThrowOnError>): RequestResult<CreateLinkResponses, CreateLinkErrors, ThrowOnError> => (options.client ?? client).post<CreateLinkResponses, CreateLinkErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/links',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteLink = <ThrowOnError extends boolean = false>(options: Options<DeleteLinkData, ThrowOnError>): RequestResult<DeleteLinkResponses, DeleteLinkErrors, ThrowOnError> => (options.client ?? client).delete<DeleteLinkResponses, DeleteLinkErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/links/{id}',
    ...options
});

export const updateLink = <ThrowOnError extends boolean = false>(options: Options<UpdateLinkData, ThrowOnError>): RequestResult<UpdateLinkResponses, UpdateLinkErrors, ThrowOnError> => (options.client ?? client).put<UpdateLinkResponses, UpdateLinkErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/links/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const reorderLinks = <ThrowOnError extends boolean = false>(options: Options<ReorderLinksData, ThrowOnError>): RequestResult<ReorderLinksResponses, ReorderLinksErrors, ThrowOnError> => (options.client ?? client).patch<ReorderLinksResponses, ReorderLinksErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/links/reorder',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listLinkCategories = <ThrowOnError extends boolean = false>(options?: Options<ListLinkCategoriesData, ThrowOnError>): RequestResult<ListLinkCategoriesResponses, ListLinkCategoriesErrors, ThrowOnError> => (options?.client ?? client).get<ListLinkCategoriesResponses, ListLinkCategoriesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/link-categories',
    ...options
});

export const createLinkCategory = <ThrowOnError extends boolean = false>(options: Options<CreateLinkCategoryData, ThrowOnError>): RequestResult<CreateLinkCategoryResponses, CreateLinkCategoryErrors, ThrowOnError> => (options.client ?? client).post<CreateLinkCategoryResponses, CreateLinkCategoryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/link-categories',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteLinkCategory = <ThrowOnError extends boolean = false>(options: Options<DeleteLinkCategoryData, ThrowOnError>): RequestResult<DeleteLinkCategoryResponses, DeleteLinkCategoryErrors, ThrowOnError> => (options.client ?? client).delete<DeleteLinkCategoryResponses, DeleteLinkCategoryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/link-categories/{id}',
    ...options
});

export const updateLinkCategory = <ThrowOnError extends boolean = false>(options: Options<UpdateLinkCategoryData, ThrowOnError>): RequestResult<UpdateLinkCategoryResponses, UpdateLinkCategoryErrors, ThrowOnError> => (options.client ?? client).put<UpdateLinkCategoryResponses, UpdateLinkCategoryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/link-categories/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const reorderLinkCategories = <ThrowOnError extends boolean = false>(options: Options<ReorderLinkCategoriesData, ThrowOnError>): RequestResult<ReorderLinkCategoriesResponses, ReorderLinkCategoriesErrors, ThrowOnError> => (options.client ?? client).patch<ReorderLinkCategoriesResponses, ReorderLinkCategoriesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/link-categories/reorder',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listProjectOverview = <ThrowOnError extends boolean = false>(options?: Options<ListProjectOverviewData, ThrowOnError>): RequestResult<ListProjectOverviewResponses, ListProjectOverviewErrors, ThrowOnError> => (options?.client ?? client).get<ListProjectOverviewResponses, ListProjectOverviewErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/projects',
    ...options
});

export const createProject = <ThrowOnError extends boolean = false>(options: Options<CreateProjectData, ThrowOnError>): RequestResult<CreateProjectResponses, CreateProjectErrors, ThrowOnError> => (options.client ?? client).post<CreateProjectResponses, CreateProjectErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/projects',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteProject = <ThrowOnError extends boolean = false>(options: Options<DeleteProjectData, ThrowOnError>): RequestResult<DeleteProjectResponses, DeleteProjectErrors, ThrowOnError> => (options.client ?? client).delete<DeleteProjectResponses, DeleteProjectErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/projects/{id}',
    ...options
});

export const setProjectBudget = <ThrowOnError extends boolean = false>(options: Options<SetProjectBudgetData, ThrowOnError>): RequestResult<SetProjectBudgetResponses, SetProjectBudgetErrors, ThrowOnError> => (options.client ?? client).put<SetProjectBudgetResponses, SetProjectBudgetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/projects/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const updateProjectDetails = <ThrowOnError extends boolean = false>(options: Options<UpdateProjectDetailsData, ThrowOnError>): RequestResult<UpdateProjectDetailsResponses, UpdateProjectDetailsErrors, ThrowOnError> => (options.client ?? client).put<UpdateProjectDetailsResponses, UpdateProjectDetailsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/projects/{id}/details',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const setProjectClosure = <ThrowOnError extends boolean = false>(options: Options<SetProjectClosureData, ThrowOnError>): RequestResult<SetProjectClosureResponses, SetProjectClosureErrors, ThrowOnError> => (options.client ?? client).put<SetProjectClosureResponses, SetProjectClosureErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/projects/{id}/closure',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listProjectMilestones = <ThrowOnError extends boolean = false>(options: Options<ListProjectMilestonesData, ThrowOnError>): RequestResult<ListProjectMilestonesResponses, ListProjectMilestonesErrors, ThrowOnError> => (options.client ?? client).get<ListProjectMilestonesResponses, ListProjectMilestonesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/projects/{id}/milestones',
    ...options
});

export const createProjectMilestone = <ThrowOnError extends boolean = false>(options: Options<CreateProjectMilestoneData, ThrowOnError>): RequestResult<CreateProjectMilestoneResponses, CreateProjectMilestoneErrors, ThrowOnError> => (options.client ?? client).post<CreateProjectMilestoneResponses, CreateProjectMilestoneErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/projects/{id}/milestones',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listApplications = <ThrowOnError extends boolean = false>(options?: Options<ListApplicationsData, ThrowOnError>): RequestResult<ListApplicationsResponses, ListApplicationsErrors, ThrowOnError> => (options?.client ?? client).get<ListApplicationsResponses, ListApplicationsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/applications',
    ...options
});

export const createApplication = <ThrowOnError extends boolean = false>(options: Options<CreateApplicationData, ThrowOnError>): RequestResult<CreateApplicationResponses, CreateApplicationErrors, ThrowOnError> => (options.client ?? client).post<CreateApplicationResponses, CreateApplicationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/applications',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteApplication = <ThrowOnError extends boolean = false>(options: Options<DeleteApplicationData, ThrowOnError>): RequestResult<DeleteApplicationResponses, DeleteApplicationErrors, ThrowOnError> => (options.client ?? client).delete<DeleteApplicationResponses, DeleteApplicationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/applications/{id}',
    ...options
});

export const updateApplication = <ThrowOnError extends boolean = false>(options: Options<UpdateApplicationData, ThrowOnError>): RequestResult<UpdateApplicationResponses, UpdateApplicationErrors, ThrowOnError> => (options.client ?? client).put<UpdateApplicationResponses, UpdateApplicationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/applications/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteMilestone = <ThrowOnError extends boolean = false>(options: Options<DeleteMilestoneData, ThrowOnError>): RequestResult<DeleteMilestoneResponses, DeleteMilestoneErrors, ThrowOnError> => (options.client ?? client).delete<DeleteMilestoneResponses, DeleteMilestoneErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/milestones/{id}',
    ...options
});

export const updateMilestone = <ThrowOnError extends boolean = false>(options: Options<UpdateMilestoneData, ThrowOnError>): RequestResult<UpdateMilestoneResponses, UpdateMilestoneErrors, ThrowOnError> => (options.client ?? client).put<UpdateMilestoneResponses, UpdateMilestoneErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/milestones/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listClientProjects = <ThrowOnError extends boolean = false>(options?: Options<ListClientProjectsData, ThrowOnError>): RequestResult<ListClientProjectsResponses, ListClientProjectsErrors, ThrowOnError> => (options?.client ?? client).get<ListClientProjectsResponses, ListClientProjectsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/projects',
    ...options
});

export const uploadFile = <ThrowOnError extends boolean = false>(options: Options<UploadFileData, ThrowOnError>): RequestResult<UploadFileResponses, UploadFileErrors, ThrowOnError> => (options.client ?? client).post<UploadFileResponses, UploadFileErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/upload',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

export const importFileFromUrl = <ThrowOnError extends boolean = false>(options: Options<ImportFileFromUrlData, ThrowOnError>): RequestResult<ImportFileFromUrlResponses, ImportFileFromUrlErrors, ThrowOnError> => (options.client ?? client).post<ImportFileFromUrlResponses, ImportFileFromUrlErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/upload/import-url',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const downloadFile = <ThrowOnError extends boolean = false>(options: Options<DownloadFileData, ThrowOnError>): RequestResult<DownloadFileResponses, DownloadFileErrors, ThrowOnError> => (options.client ?? client).get<DownloadFileResponses, DownloadFileErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/files/{path}',
    ...options
});

export const lookupIssues = <ThrowOnError extends boolean = false>(options: Options<LookupIssuesData, ThrowOnError>): RequestResult<LookupIssuesResponses, LookupIssuesErrors, ThrowOnError> => (options.client ?? client).get<LookupIssuesResponses, LookupIssuesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/issues/lookup',
    ...options
});

export const resolveIssueIdentifier = <ThrowOnError extends boolean = false>(options: Options<ResolveIssueIdentifierData, ThrowOnError>): RequestResult<ResolveIssueIdentifierResponses, ResolveIssueIdentifierErrors, ThrowOnError> => (options.client ?? client).get<ResolveIssueIdentifierResponses, ResolveIssueIdentifierErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/issues/resolve',
    ...options
});

export const listIssues = <ThrowOnError extends boolean = false>(options?: Options<ListIssuesData, ThrowOnError>): RequestResult<ListIssuesResponses, ListIssuesErrors, ThrowOnError> => (options?.client ?? client).get<ListIssuesResponses, ListIssuesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/issues',
    ...options
});

export const createIssue = <ThrowOnError extends boolean = false>(options: Options<CreateIssueData, ThrowOnError>): RequestResult<CreateIssueResponses, CreateIssueErrors, ThrowOnError> => (options.client ?? client).post<CreateIssueResponses, CreateIssueErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/issues',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteIssue = <ThrowOnError extends boolean = false>(options: Options<DeleteIssueData, ThrowOnError>): RequestResult<DeleteIssueResponses, DeleteIssueErrors, ThrowOnError> => (options.client ?? client).delete<DeleteIssueResponses, DeleteIssueErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/issues/{id}',
    ...options
});

export const getIssue = <ThrowOnError extends boolean = false>(options: Options<GetIssueData, ThrowOnError>): RequestResult<GetIssueResponses, GetIssueErrors, ThrowOnError> => (options.client ?? client).get<GetIssueResponses, GetIssueErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/issues/{id}',
    ...options
});

export const updateIssue = <ThrowOnError extends boolean = false>(options: Options<UpdateIssueData, ThrowOnError>): RequestResult<UpdateIssueResponses, UpdateIssueErrors, ThrowOnError> => (options.client ?? client).put<UpdateIssueResponses, UpdateIssueErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/issues/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const setIssueState = <ThrowOnError extends boolean = false>(options: Options<SetIssueStateData, ThrowOnError>): RequestResult<SetIssueStateResponses, SetIssueStateErrors, ThrowOnError> => (options.client ?? client).put<SetIssueStateResponses, SetIssueStateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/issues/{id}/state',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const setIssueAssignee = <ThrowOnError extends boolean = false>(options: Options<SetIssueAssigneeData, ThrowOnError>): RequestResult<SetIssueAssigneeResponses, SetIssueAssigneeErrors, ThrowOnError> => (options.client ?? client).put<SetIssueAssigneeResponses, SetIssueAssigneeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/issues/{id}/assignment',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const setIssueFlags = <ThrowOnError extends boolean = false>(options: Options<SetIssueFlagsData, ThrowOnError>): RequestResult<SetIssueFlagsResponses, SetIssueFlagsErrors, ThrowOnError> => (options.client ?? client).put<SetIssueFlagsResponses, SetIssueFlagsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/issues/{id}/flags',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const setIssueParent = <ThrowOnError extends boolean = false>(options: Options<SetIssueParentData, ThrowOnError>): RequestResult<SetIssueParentResponses, SetIssueParentErrors, ThrowOnError> => (options.client ?? client).put<SetIssueParentResponses, SetIssueParentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/issues/{id}/parent',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const setIssueValidation = <ThrowOnError extends boolean = false>(options: Options<SetIssueValidationData, ThrowOnError>): RequestResult<SetIssueValidationResponses, SetIssueValidationErrors, ThrowOnError> => (options.client ?? client).post<SetIssueValidationResponses, SetIssueValidationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/issues/{id}/validation',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listIssueMergeRequests = <ThrowOnError extends boolean = false>(options: Options<ListIssueMergeRequestsData, ThrowOnError>): RequestResult<ListIssueMergeRequestsResponses, ListIssueMergeRequestsErrors, ThrowOnError> => (options.client ?? client).get<ListIssueMergeRequestsResponses, ListIssueMergeRequestsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/issues/{id}/merge-requests',
    ...options
});

export const createIssueComment = <ThrowOnError extends boolean = false>(options: Options<CreateIssueCommentData, ThrowOnError>): RequestResult<CreateIssueCommentResponses, CreateIssueCommentErrors, ThrowOnError> => (options.client ?? client).post<CreateIssueCommentResponses, CreateIssueCommentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/issues/{id}/comments',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const updateIssueComment = <ThrowOnError extends boolean = false>(options: Options<UpdateIssueCommentData, ThrowOnError>): RequestResult<UpdateIssueCommentResponses, UpdateIssueCommentErrors, ThrowOnError> => (options.client ?? client).put<UpdateIssueCommentResponses, UpdateIssueCommentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/issues/{id}/comments/{commentId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const createAttachment = <ThrowOnError extends boolean = false>(options: Options<CreateAttachmentData, ThrowOnError>): RequestResult<CreateAttachmentResponses, CreateAttachmentErrors, ThrowOnError> => (options.client ?? client).post<CreateAttachmentResponses, CreateAttachmentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/attachments',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteAttachment = <ThrowOnError extends boolean = false>(options: Options<DeleteAttachmentData, ThrowOnError>): RequestResult<DeleteAttachmentResponses, DeleteAttachmentErrors, ThrowOnError> => (options.client ?? client).delete<DeleteAttachmentResponses, DeleteAttachmentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/attachments/{id}',
    ...options
});

export const downloadAttachment = <ThrowOnError extends boolean = false>(options: Options<DownloadAttachmentData, ThrowOnError>): RequestResult<DownloadAttachmentResponses, DownloadAttachmentErrors, ThrowOnError> => (options.client ?? client).get<DownloadAttachmentResponses, DownloadAttachmentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/attachments/{id}/download',
    ...options
});

export const listClientLabels = <ThrowOnError extends boolean = false>(options?: Options<ListClientLabelsData, ThrowOnError>): RequestResult<ListClientLabelsResponses, ListClientLabelsErrors, ThrowOnError> => (options?.client ?? client).get<ListClientLabelsResponses, ListClientLabelsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/labels',
    ...options
});

export const handleGitlabWebhook = <ThrowOnError extends boolean = false>(options: Options<HandleGitlabWebhookData, ThrowOnError>): RequestResult<HandleGitlabWebhookResponses, HandleGitlabWebhookErrors, ThrowOnError> => (options.client ?? client).post<HandleGitlabWebhookResponses, HandleGitlabWebhookErrors, ThrowOnError>({
    url: '/api/webhooks/gitlab',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listGitlabMergeRequests = <ThrowOnError extends boolean = false>(options?: Options<ListGitlabMergeRequestsData, ThrowOnError>): RequestResult<ListGitlabMergeRequestsResponses, ListGitlabMergeRequestsErrors, ThrowOnError> => (options?.client ?? client).get<ListGitlabMergeRequestsResponses, ListGitlabMergeRequestsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/gitlab/merge-requests',
    ...options
});

export const deleteGitlabToken = <ThrowOnError extends boolean = false>(options?: Options<DeleteGitlabTokenData, ThrowOnError>): RequestResult<DeleteGitlabTokenResponses, DeleteGitlabTokenErrors, ThrowOnError> => (options?.client ?? client).delete<DeleteGitlabTokenResponses, DeleteGitlabTokenErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/profile/gitlab-token',
    ...options
});

export const getGitlabTokenStatus = <ThrowOnError extends boolean = false>(options?: Options<GetGitlabTokenStatusData, ThrowOnError>): RequestResult<GetGitlabTokenStatusResponses, GetGitlabTokenStatusErrors, ThrowOnError> => (options?.client ?? client).get<GetGitlabTokenStatusResponses, GetGitlabTokenStatusErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/profile/gitlab-token',
    ...options
});

export const setGitlabToken = <ThrowOnError extends boolean = false>(options: Options<SetGitlabTokenData, ThrowOnError>): RequestResult<SetGitlabTokenResponses, SetGitlabTokenErrors, ThrowOnError> => (options.client ?? client).put<SetGitlabTokenResponses, SetGitlabTokenErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/profile/gitlab-token',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listTimesheetEntries = <ThrowOnError extends boolean = false>(options: Options<ListTimesheetEntriesData, ThrowOnError>): RequestResult<ListTimesheetEntriesResponses, ListTimesheetEntriesErrors, ThrowOnError> => (options.client ?? client).get<ListTimesheetEntriesResponses, ListTimesheetEntriesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/timesheet/entries',
    ...options
});

export const createTimesheetEntry = <ThrowOnError extends boolean = false>(options: Options<CreateTimesheetEntryData, ThrowOnError>): RequestResult<CreateTimesheetEntryResponses, CreateTimesheetEntryErrors, ThrowOnError> => (options.client ?? client).post<CreateTimesheetEntryResponses, CreateTimesheetEntryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/timesheet/entries',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteTimesheetEntry = <ThrowOnError extends boolean = false>(options: Options<DeleteTimesheetEntryData, ThrowOnError>): RequestResult<DeleteTimesheetEntryResponses, DeleteTimesheetEntryErrors, ThrowOnError> => (options.client ?? client).delete<DeleteTimesheetEntryResponses, DeleteTimesheetEntryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/timesheet/entries/{id}',
    ...options
});

export const updateTimesheetEntry = <ThrowOnError extends boolean = false>(options: Options<UpdateTimesheetEntryData, ThrowOnError>): RequestResult<UpdateTimesheetEntryResponses, UpdateTimesheetEntryErrors, ThrowOnError> => (options.client ?? client).put<UpdateTimesheetEntryResponses, UpdateTimesheetEntryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/timesheet/entries/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getTimesheetSettings = <ThrowOnError extends boolean = false>(options?: Options<GetTimesheetSettingsData, ThrowOnError>): RequestResult<GetTimesheetSettingsResponses, GetTimesheetSettingsErrors, ThrowOnError> => (options?.client ?? client).get<GetTimesheetSettingsResponses, GetTimesheetSettingsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/timesheet/settings',
    ...options
});

export const setTimesheetSettings = <ThrowOnError extends boolean = false>(options: Options<SetTimesheetSettingsData, ThrowOnError>): RequestResult<SetTimesheetSettingsResponses, SetTimesheetSettingsErrors, ThrowOnError> => (options.client ?? client).put<SetTimesheetSettingsResponses, SetTimesheetSettingsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/timesheet/settings',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listTimesheetCatalogClients = <ThrowOnError extends boolean = false>(options?: Options<ListTimesheetCatalogClientsData, ThrowOnError>): RequestResult<ListTimesheetCatalogClientsResponses, ListTimesheetCatalogClientsErrors, ThrowOnError> => (options?.client ?? client).get<ListTimesheetCatalogClientsResponses, ListTimesheetCatalogClientsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/timesheet/catalog/clients',
    ...options
});

export const listTimesheetCatalogApplications = <ThrowOnError extends boolean = false>(options?: Options<ListTimesheetCatalogApplicationsData, ThrowOnError>): RequestResult<ListTimesheetCatalogApplicationsResponses, ListTimesheetCatalogApplicationsErrors, ThrowOnError> => (options?.client ?? client).get<ListTimesheetCatalogApplicationsResponses, ListTimesheetCatalogApplicationsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/timesheet/catalog/applications',
    ...options
});

export const listTimesheetCatalogProjects = <ThrowOnError extends boolean = false>(options?: Options<ListTimesheetCatalogProjectsData, ThrowOnError>): RequestResult<ListTimesheetCatalogProjectsResponses, ListTimesheetCatalogProjectsErrors, ThrowOnError> => (options?.client ?? client).get<ListTimesheetCatalogProjectsResponses, ListTimesheetCatalogProjectsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/timesheet/catalog/projects',
    ...options
});

export const lookupTimesheetIssue = <ThrowOnError extends boolean = false>(options: Options<LookupTimesheetIssueData, ThrowOnError>): RequestResult<LookupTimesheetIssueResponses, LookupTimesheetIssueErrors, ThrowOnError> => (options.client ?? client).get<LookupTimesheetIssueResponses, LookupTimesheetIssueErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/timesheet/issue-lookup',
    ...options
});

export const getAdminTimesheetOverview = <ThrowOnError extends boolean = false>(options: Options<GetAdminTimesheetOverviewData, ThrowOnError>): RequestResult<GetAdminTimesheetOverviewResponses, GetAdminTimesheetOverviewErrors, ThrowOnError> => (options.client ?? client).get<GetAdminTimesheetOverviewResponses, GetAdminTimesheetOverviewErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/timesheet',
    ...options
});

export const listTrackerProjects = <ThrowOnError extends boolean = false>(options?: Options<ListTrackerProjectsData, ThrowOnError>): RequestResult<ListTrackerProjectsResponses, ListTrackerProjectsErrors, ThrowOnError> => (options?.client ?? client).get<ListTrackerProjectsResponses, ListTrackerProjectsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/tracker/projects',
    ...options
});

export const listProjectDocuments = <ThrowOnError extends boolean = false>(options: Options<ListProjectDocumentsData, ThrowOnError>): RequestResult<ListProjectDocumentsResponses, ListProjectDocumentsErrors, ThrowOnError> => (options.client ?? client).get<ListProjectDocumentsResponses, ListProjectDocumentsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/tracker/projects/{projectId}/documents',
    ...options
});

export const uploadProjectDocument = <ThrowOnError extends boolean = false>(options: Options<UploadProjectDocumentData, ThrowOnError>): RequestResult<UploadProjectDocumentResponses, UploadProjectDocumentErrors, ThrowOnError> => (options.client ?? client).post<UploadProjectDocumentResponses, UploadProjectDocumentErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/tracker/projects/{projectId}/documents',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

export const deleteProjectDocument = <ThrowOnError extends boolean = false>(options: Options<DeleteProjectDocumentData, ThrowOnError>): RequestResult<DeleteProjectDocumentResponses, DeleteProjectDocumentErrors, ThrowOnError> => (options.client ?? client).delete<DeleteProjectDocumentResponses, DeleteProjectDocumentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/tracker/documents/{id}',
    ...options
});

export const downloadProjectDocument = <ThrowOnError extends boolean = false>(options: Options<DownloadProjectDocumentData, ThrowOnError>): RequestResult<DownloadProjectDocumentResponses, DownloadProjectDocumentErrors, ThrowOnError> => (options.client ?? client).get<DownloadProjectDocumentResponses, DownloadProjectDocumentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/tracker/documents/{id}/download',
    ...options
});

export const searchMeetingParticipants = <ThrowOnError extends boolean = false>(options?: Options<SearchMeetingParticipantsData, ThrowOnError>): RequestResult<SearchMeetingParticipantsResponses, SearchMeetingParticipantsErrors, ThrowOnError> => (options?.client ?? client).get<SearchMeetingParticipantsResponses, SearchMeetingParticipantsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/tracker/meeting-participants',
    ...options
});

export const summarizeMeeting = <ThrowOnError extends boolean = false>(options: Options<SummarizeMeetingData, ThrowOnError>): RequestResult<SummarizeMeetingResponses, SummarizeMeetingErrors, ThrowOnError> => (options.client ?? client).post<SummarizeMeetingResponses, SummarizeMeetingErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/tracker/meetings/{id}/summarize',
    ...options
});

export const reviewMeeting = <ThrowOnError extends boolean = false>(options: Options<ReviewMeetingData, ThrowOnError>): RequestResult<ReviewMeetingResponses, ReviewMeetingErrors, ThrowOnError> => (options.client ?? client).post<ReviewMeetingResponses, ReviewMeetingErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/tracker/meetings/{id}/review',
    ...options
});

export const publishMeeting = <ThrowOnError extends boolean = false>(options: Options<PublishMeetingData, ThrowOnError>): RequestResult<PublishMeetingResponses, PublishMeetingErrors, ThrowOnError> => (options.client ?? client).post<PublishMeetingResponses, PublishMeetingErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/tracker/meetings/{id}/publish',
    ...options
});

export const unpublishMeeting = <ThrowOnError extends boolean = false>(options: Options<UnpublishMeetingData, ThrowOnError>): RequestResult<UnpublishMeetingResponses, UnpublishMeetingErrors, ThrowOnError> => (options.client ?? client).post<UnpublishMeetingResponses, UnpublishMeetingErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/tracker/meetings/{id}/unpublish',
    ...options
});

export const createMeetingDecision = <ThrowOnError extends boolean = false>(options: Options<CreateMeetingDecisionData, ThrowOnError>): RequestResult<CreateMeetingDecisionResponses, CreateMeetingDecisionErrors, ThrowOnError> => (options.client ?? client).post<CreateMeetingDecisionResponses, CreateMeetingDecisionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/tracker/meetings/{id}/decisions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const updateMeetingDecision = <ThrowOnError extends boolean = false>(options: Options<UpdateMeetingDecisionData, ThrowOnError>): RequestResult<UpdateMeetingDecisionResponses, UpdateMeetingDecisionErrors, ThrowOnError> => (options.client ?? client).put<UpdateMeetingDecisionResponses, UpdateMeetingDecisionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/tracker/meetings/{id}/decisions/{did}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const setMeetingAttendees = <ThrowOnError extends boolean = false>(options: Options<SetMeetingAttendeesData, ThrowOnError>): RequestResult<SetMeetingAttendeesResponses, SetMeetingAttendeesErrors, ThrowOnError> => (options.client ?? client).put<SetMeetingAttendeesResponses, SetMeetingAttendeesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/tracker/meetings/{id}/attendees',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listActionItemCandidates = <ThrowOnError extends boolean = false>(options: Options<ListActionItemCandidatesData, ThrowOnError>): RequestResult<ListActionItemCandidatesResponses, ListActionItemCandidatesErrors, ThrowOnError> => (options.client ?? client).get<ListActionItemCandidatesResponses, ListActionItemCandidatesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/tracker/meetings/{id}/action-items/{aid}/candidates',
    ...options
});

export const linkActionItem = <ThrowOnError extends boolean = false>(options: Options<LinkActionItemData, ThrowOnError>): RequestResult<LinkActionItemResponses, LinkActionItemErrors, ThrowOnError> => (options.client ?? client).post<LinkActionItemResponses, LinkActionItemErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/tracker/meetings/{id}/action-items/{aid}/link',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const createIssueFromActionItem = <ThrowOnError extends boolean = false>(options: Options<CreateIssueFromActionItemData, ThrowOnError>): RequestResult<CreateIssueFromActionItemResponses, CreateIssueFromActionItemErrors, ThrowOnError> => (options.client ?? client).post<CreateIssueFromActionItemResponses, CreateIssueFromActionItemErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/tracker/meetings/{id}/action-items/{aid}/create-issue',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const updateActionItem = <ThrowOnError extends boolean = false>(options: Options<UpdateActionItemData, ThrowOnError>): RequestResult<UpdateActionItemResponses, UpdateActionItemErrors, ThrowOnError> => (options.client ?? client).put<UpdateActionItemResponses, UpdateActionItemErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/tracker/meetings/{id}/action-items/{aid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listMeetings = <ThrowOnError extends boolean = false>(options?: Options<ListMeetingsData, ThrowOnError>): RequestResult<ListMeetingsResponses, ListMeetingsErrors, ThrowOnError> => (options?.client ?? client).get<ListMeetingsResponses, ListMeetingsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/tracker/meetings',
    ...options
});

export const createMeeting = <ThrowOnError extends boolean = false>(options: Options<CreateMeetingData, ThrowOnError>): RequestResult<CreateMeetingResponses, CreateMeetingErrors, ThrowOnError> => (options.client ?? client).post<CreateMeetingResponses, CreateMeetingErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/tracker/meetings',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteMeeting = <ThrowOnError extends boolean = false>(options: Options<DeleteMeetingData, ThrowOnError>): RequestResult<DeleteMeetingResponses, DeleteMeetingErrors, ThrowOnError> => (options.client ?? client).delete<DeleteMeetingResponses, DeleteMeetingErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/tracker/meetings/{id}',
    ...options
});

export const getMeeting = <ThrowOnError extends boolean = false>(options: Options<GetMeetingData, ThrowOnError>): RequestResult<GetMeetingResponses, GetMeetingErrors, ThrowOnError> => (options.client ?? client).get<GetMeetingResponses, GetMeetingErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/tracker/meetings/{id}',
    ...options
});

export const updateMeeting = <ThrowOnError extends boolean = false>(options: Options<UpdateMeetingData, ThrowOnError>): RequestResult<UpdateMeetingResponses, UpdateMeetingErrors, ThrowOnError> => (options.client ?? client).put<UpdateMeetingResponses, UpdateMeetingErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/tracker/meetings/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
